import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const loggedinUser = createReducer(null, {
    [types.LOGIN_USER](state, action) {
        let newState = action.user;
        return newState;
    },
    [types.LOGOUT_USER](state, action) {
        return null;
    }
});

export const isLoggedin = createReducer(false, {
    [types.LOGIN_USER](state, action) {
        return true;
    },
    [types.LOGOUT_USER](state, action) {
        return false;
    }
});


// WEBPACK FOOTER //
// ./src/reducers/auth.js